import React, {Component} from "react";
import {NaverMap, Marker} from "react-naver-maps";

class AddressSearchNaverMap extends Component{

    render(){
        const rootStore = this.props.rootStore;
        const navermaps = window.naver.maps;
        
        return(
            <div className={"map"}>
            {
                (rootStore.addressSearchStore.getKakaoMapLat)?    
                    <NaverMap  
                        mapDivId={'react-naver-map'} style={{ width: "100%", height: "316px" }}
                        center={{ lat: rootStore.addressSearchStore.getKakaoMapLat, lng: rootStore.addressSearchStore.getKakaoMapLng }}
                        //defaultZoom={17}
                        //zoomControl= {true}
                    >
                        <Marker
                            position={new navermaps.LatLng( rootStore.addressSearchStore.getKakaoMapLat, rootStore.addressSearchStore.getKakaoMapLng )}
                        />
                    </NaverMap>
                    :null
            }
            </div>
        )
        
    }
}

export default AddressSearchNaverMap;